import React, { FunctionComponent } from 'react';

export const Placeholder: FunctionComponent<any> = () => <div />;

export default Placeholder;
